import { inject } from '@angular/core'
import type { CanActivateFn } from '@angular/router'
import { Router } from '@angular/router'

export const hasStateParameterGuard: (
  parameters: string[],
  redirect?: string[]
) => CanActivateFn = (parameters: string[], redirect?: string[]) => () => {
  const router = inject(Router)

  const state = router.currentNavigation()?.extras?.state

  if (state && parameters.every(parameter => state[parameter] !== undefined)) {
    return true
  }
  return (redirect?.length ?? 0) > 0 ? router.createUrlTree(redirect!) : false
}
